__turbopack_context__.v({
  "bottomLine": "BusinessSolutionsSection-module__cYMRhW__bottomLine",
  "bottomRow": "BusinessSolutionsSection-module__cYMRhW__bottomRow",
  "btnArrowIcon": "BusinessSolutionsSection-module__cYMRhW__btnArrowIcon",
  "cardBox": "BusinessSolutionsSection-module__cYMRhW__cardBox",
  "cardDesc": "BusinessSolutionsSection-module__cYMRhW__cardDesc",
  "cardDetails": "BusinessSolutionsSection-module__cYMRhW__cardDetails",
  "cardDivider": "BusinessSolutionsSection-module__cYMRhW__cardDivider",
  "cardIconBox": "BusinessSolutionsSection-module__cYMRhW__cardIconBox",
  "cardImageArea": "BusinessSolutionsSection-module__cYMRhW__cardImageArea",
  "cardTitle": "BusinessSolutionsSection-module__cYMRhW__cardTitle",
  "cardTopLeft": "BusinessSolutionsSection-module__cYMRhW__cardTopLeft",
  "categoryTag": "BusinessSolutionsSection-module__cYMRhW__categoryTag",
  "cornerBottomRight": "BusinessSolutionsSection-module__cYMRhW__cornerBottomRight",
  "cornerTopRight": "BusinessSolutionsSection-module__cYMRhW__cornerTopRight",
  "customBtn": "BusinessSolutionsSection-module__cYMRhW__customBtn",
  "earlyBtn": "BusinessSolutionsSection-module__cYMRhW__earlyBtn",
  "emailIcon": "BusinessSolutionsSection-module__cYMRhW__emailIcon",
  "emailInput": "BusinessSolutionsSection-module__cYMRhW__emailInput",
  "featureOverlay": "BusinessSolutionsSection-module__cYMRhW__featureOverlay",
  "headerContainer": "BusinessSolutionsSection-module__cYMRhW__headerContainer",
  "headerTitle": "BusinessSolutionsSection-module__cYMRhW__headerTitle",
  "inputWrapper": "BusinessSolutionsSection-module__cYMRhW__inputWrapper",
  "mainHeading": "BusinessSolutionsSection-module__cYMRhW__mainHeading",
  "price": "BusinessSolutionsSection-module__cYMRhW__price",
  "priceNumber": "BusinessSolutionsSection-module__cYMRhW__priceNumber",
  "sectionWrapper": "BusinessSolutionsSection-module__cYMRhW__sectionWrapper",
  "subText": "BusinessSolutionsSection-module__cYMRhW__subText",
  "titleRow": "BusinessSolutionsSection-module__cYMRhW__titleRow",
});
